import { BaseFirestoreService } from "../FirestoreService";
import { Listing, LISTINGS_COLLECTION } from "../../db/listings";
import { ListingPhotosService } from "./ListingPhotosService";
import { ListingReviewsService } from "./ListingReviewsService";

/**
 * Shared Listing Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ListingService extends BaseFirestoreService<Listing> {
    protected getCollectionPath(): string {
        return LISTINGS_COLLECTION;
    }

    public listingPhotosService(listingId: string): ListingPhotosService {
        return new ListingPhotosService(this.firestore, listingId)
    }

    public listingReviewsService(listingId: string): ListingReviewsService {
        return new ListingReviewsService(this.firestore, listingId)
    }
}
